var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSunIconYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9417 16.0228C27.6495 16.0628 28.3401 16.037 29.0426 16.0768C29.5107 16.1032 29.8893 16.0804 30.3425 16.0242C30.5445 15.9992 30.7645 15.9148 30.9677 15.9263",
    stroke: "#FDBB11",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.32093 17.9667C2.54196 18.0064 2.77899 17.8873 3.00355 17.8804C3.32478 17.8705 3.5228 17.9083 3.8266 17.8074C4.01177 17.7459 4.2483 17.6513 4.44536 17.6631C4.72412 17.6798 5.05116 17.5582 5.33413 17.535C5.55336 17.517 5.68991 17.4021 5.87554 17.3523",
    stroke: "#FDBB11",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88902 8.62878C9.75011 8.39884 9.58401 8.2309 9.39437 8.03682C9.03608 7.67015 8.70194 7.13465 8.27304 6.84702C8.1064 6.73527 7.93273 6.50836 7.7657 6.42547C7.69304 6.38941 7.55659 6.34647 7.53955 6.27087",
    stroke: "#FDBB11",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1688 26.5442C23.0869 26.2956 22.9666 26.1027 22.8298 25.8802C22.5712 25.4598 22.3705 24.8789 22.0295 24.5232C21.897 24.385 21.7819 24.1332 21.6431 24.0231C21.5827 23.9752 21.464 23.9093 21.4639 23.8326",
    stroke: "#FDBB11",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.795 26.1584C12.8222 26.2938 12.7706 26.4213 12.7381 26.553C12.6864 26.7623 12.7143 26.9636 12.6648 27.1773C12.5539 27.6565 12.5033 28.1386 12.3053 28.5978C12.1873 28.8715 12.1448 29.1655 12.0609 29.4515C11.9812 29.7232 11.8355 29.9457 11.7168 30.1998C11.633 30.3792 11.5858 30.5574 11.4899 30.7278C11.4496 30.7994 11.4612 30.9212 11.3721 30.9413",
    stroke: "#FDBB11",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4688 2.35049C21.5007 2.48486 21.4537 2.61417 21.4259 2.74696C21.3817 2.95788 21.4168 3.15813 21.375 3.37342C21.2812 3.85624 21.2478 4.33986 21.0663 4.80582C20.9581 5.08356 20.9261 5.37887 20.8524 5.66775C20.7825 5.94205 20.6448 6.16967 20.5352 6.42783C20.4578 6.61002 20.4171 6.78985 20.3273 6.96351C20.2895 7.0365 20.3055 7.15781 20.2172 7.18106",
    stroke: "#FDBB11",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4243 16.8153C20.4243 17.5679 20.0233 18.2005 19.1175 18.7204C18.1813 19.2578 16.8633 19.557 15.5578 19.557C14.5405 19.557 13.785 19.1352 13.2501 18.4633C12.6905 17.7604 12.3418 16.7334 12.3418 15.5678C12.3418 14.723 12.7849 13.9519 13.6531 13.3347C14.5363 12.7069 15.7593 12.327 16.9725 12.327C17.9035 12.327 18.7327 12.796 19.3777 13.6441C20.0349 14.5081 20.4243 15.6834 20.4243 16.8153Z",
    stroke: "#FDBB11",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunIconYellow);
export default __webpack_public_path__ + "static/media/sun-icon-yellow.b49f8d2b4089da07828a1f3897195bb2.svg";
export { ForwardRef as ReactComponent };